import React, { createContext, useState, useEffect } from "react";
import { auth, db } from "../firebase/firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { updateUserData, fetchUserData } from "../utils/userData";

export const NodeButtonsContext = createContext({
  showNodeButtons: false,
  setShowNodeButtons: () => {},
});

export const NodeButtonsProvider = ({ children }) => {
  const [showNodeButtons, setShowNodeButtonsState] = useState(false);

  useEffect(() => {
    let unsubscribe = () => {};
    const currentUser = auth.currentUser;

    if (currentUser) {
      const fromLS = localStorage.getItem(`showNodeButtons_${currentUser.uid}`);
      if (fromLS !== null) {
        setShowNodeButtonsState(JSON.parse(fromLS));
      }

      fetchUserData(currentUser.uid).then((userData) => {
        if (userData && typeof userData.showNodeButtons === "boolean") {
          setShowNodeButtonsState(userData.showNodeButtons);
          if (JSON.parse(fromLS || "false") !== userData.showNodeButtons) {
            localStorage.setItem(
              `showNodeButtons_${currentUser.uid}`,
              JSON.stringify(userData.showNodeButtons)
            );
          }
        } else if (userData && typeof userData.showNodeButtons === "undefined") {
          updateUserData(currentUser.uid, { showNodeButtons });
        }
      });

      const userDocRef = doc(db, "users", currentUser.uid);
      unsubscribe = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (typeof data.showNodeButtons === "boolean") {
            setShowNodeButtonsState(data.showNodeButtons);
            localStorage.setItem(
              `showNodeButtons_${currentUser.uid}`,
              JSON.stringify(data.showNodeButtons)
            );
          }
        }
      });
    }

    return () => unsubscribe();
  }, [auth.currentUser]);

  const setShowNodeButtons = async (value) => {
    const currentUser = auth.currentUser;
    setShowNodeButtonsState(value);
    localStorage.setItem(`showNodeButtons_${currentUser?.uid}`, JSON.stringify(value));

    if (currentUser) {
      try {
        await updateUserData(currentUser.uid, { showNodeButtons: value });
      } catch (error) {
        console.error("Failed to update showNodeButtons in Firestore:", error);
      }
    }
  };

  return (
    <NodeButtonsContext.Provider value={{ showNodeButtons, setShowNodeButtons }}>
      {children}
    </NodeButtonsContext.Provider>
  );
};
